import { render } from "./SectView.vue?vue&type=template&id=7832efaf&scoped=true"
import script from "./SectView.vue?vue&type=script&lang=js"
export * from "./SectView.vue?vue&type=script&lang=js"

import "./SectView.vue?vue&type=style&index=0&id=7832efaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7832efaf"]])

export default __exports__